import React from 'react';
import PropTypes from 'prop-types';

import { listingFormFields } from 'common/listingFormFields';

import { getOwnerPaysForFields } from 'common/listingHelpers';

import SrTable, { SR_TABLE_THEME_SMALL } from 'client/components/SrTable';
import SrText from 'client/components/SrText';
import SrIcon from 'client/components/SrIcon';

const SrWhoCoversTheBillsInfoBlock = ({ property }) => {
  const ownerPaysForFields = getOwnerPaysForFields(property);
  return (
    <div className="SrWhoCoversTheBillsInfoBlock selfContained">
      <SrTable
        theme={SR_TABLE_THEME_SMALL}
        noPadding
        headers={[
          {
            content: (
              <SrText weight="bold" font="whitney-sc">
                bill
              </SrText>
            ),
          },
          {
            content: (
              <SrText weight="bold" font="whitney-sc">
                renter
              </SrText>
            ),
          },
          {
            content: (
              <SrText weight="bold" font="whitney-sc">
                owner
              </SrText>
            ),
          },
        ]}
        rows={Object.keys(ownerPaysForFields).map((fieldId) => {
          const fieldTitle = listingFormFields
            .find(({ id }) => id === fieldId)
            .title.replace('Owner Pays ', '');
          return {
            cells: [
              { content: fieldTitle },
              {
                content: !ownerPaysForFields[fieldId] ? (
                  <SrIcon className="checkmark-rounded-green" />
                ) : (
                  ''
                ),
              },
              {
                content: ownerPaysForFields[fieldId] ? (
                  <SrIcon className="checkmark-rounded-green" />
                ) : (
                  ''
                ),
              },
            ],
          };
        })}
      />
    </div>
  );
};

SrWhoCoversTheBillsInfoBlock.propTypes = {
  property: PropTypes.object.isRequired,
};

SrWhoCoversTheBillsInfoBlock.displayName = 'SrWhoCoversTheBillsInfoBlock';

export default SrWhoCoversTheBillsInfoBlock;
